import { useState, useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import API from '../utils/api';
import { useAuth } from '../context/AuthContext';
import ListingCard from '../components/listings/ListingCard';

const API_BASE = process.env.REACT_APP_API_URL?.replace('/api', '') || '';

export default function BarterBrowsePage() {
  const navigate = useNavigate();
  const { user } = useAuth();
  const [searchParams] = useSearchParams();

  const [listings, setListings] = useState([]);
  const [loading, setLoading] = useState(false);
  const [q, setQ] = useState(searchParams.get('q') || '');

  useEffect(() => {
    const fetchListings = async () => {
      setLoading(true);
      try {
        const { data } = await API.get('/barters/listings', {
          params: { q, limit: 20 }
        });
        setListings(data.listings || []);
      } catch (err) {
        console.error(err);
      } finally {
        setLoading(false);
      }
    };
    fetchListings();
  }, [q]);

  return (
    <div style={{ maxWidth: 1200, margin: '0 auto', padding: '40px 48px 80px' }}>
      <div style={{ marginBottom: 40 }}>
        <h1 style={{ fontFamily: "'Playfair Display',serif", fontSize: 32, fontWeight: 700, marginBottom: 12 }}>
          🔄 Barter Items
        </h1>
        <p style={{ fontSize: 15, color: 'var(--text-mid)', marginBottom: 24 }}>
          Trade items with others in your community. No money needed — just swap!
        </p>

        <div style={{ display: 'flex', gap: 12, marginBottom: 24 }}>
          <input
            type="text"
            placeholder="Search barter items..."
            value={q}
            onChange={e => setQ(e.target.value)}
            style={{
              flex: 1,
              padding: '12px 16px',
              border: '1px solid var(--border)',
              borderRadius: 10,
              fontSize: 14,
              fontFamily: "'DM Sans', sans-serif"
            }}
          />
          {user && (
            <button
              className="btn btn-cherry"
              onClick={() => navigate('/barter/create')}
            >
              + Create Barter Listing
            </button>
          )}
        </div>
      </div>

      {loading ? (
        <div style={{ textAlign: 'center', padding: '40px' }}>
          <div style={{ fontSize: 40 }} className="float-anim">🍒</div>
          <div style={{ fontSize: 14, color: 'var(--text-soft)', marginTop: 12 }}>Loading...</div>
        </div>
      ) : listings.length === 0 ? (
        <div style={{ textAlign: 'center', padding: '60px 40px' }}>
          <div style={{ fontSize: 56, marginBottom: 20 }}>🔄</div>
          <h2 style={{ fontFamily: "'Playfair Display',serif", fontSize: 24, marginBottom: 12 }}>
            No barter items found
          </h2>
          {user ? (
            <>
              <p style={{ color: 'var(--text-mid)', marginBottom: 24 }}>
                Be the first to list an item for trade!
              </p>
              <button
                className="btn btn-cherry btn-lg"
                onClick={() => navigate('/barter/create')}
              >
                Create a Barter Listing
              </button>
            </>
          ) : (
            <>
              <p style={{ color: 'var(--text-mid)', marginBottom: 24 }}>
                Sign in to create barter listings and start trading.
              </p>
              <button
                className="btn btn-cherry btn-lg"
                onClick={() => navigate('/login?redirect=/barter')}
              >
                Sign In
              </button>
            </>
          )}
        </div>
      ) : (
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(220px, 1fr))', gap: 18 }}>
          {listings.map((listing, i) => (
            <ListingCard key={listing.id} listing={listing} delay={i * 0.07} />
          ))}
        </div>
      )}
    </div>
  );
}
